import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef, NgZone } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { ResponseChangeModel } from 'src/app/incident/incident.component';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';


@Component({
  selector: 'app-inputType-radio',
  templateUrl: './inputType-radio.component.html',
  styleUrls: ['./inputType-radio.component.scss']
,  standalone: false
})
export class InputTypeRadioComponent implements OnInit, OnChanges {

  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Input() showName?: boolean=true;
  @Input() isMatrix?: boolean=false;
  @Input() IsReadOnly?:boolean=false;
  @Input() IsConsentScreen?:boolean=false;
  //@Output() checkInputChange: EventEmitter<{event: MatRadioChange, proceed: (shouldProceed: boolean) => void}> = new EventEmitter();
  @Output() conditionalChange: EventEmitter<ResponseChangeModel> = new EventEmitter<ResponseChangeModel>();

  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];

  constructor(private cdr: ChangeDetectorRef, private zone: NgZone) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['question'] && changes['question'].currentValue) {
      const currentQuestion = changes['question'].currentValue;
      this.question = { ...currentQuestion }; // Create a new reference to trigger change detection
      if (this.question.responseText && this.question.responseText.length > 0) {      
        this.question.options.forEach(option => {
          option["selected"] = option.value === this.question.responseText
        });       
      } else {        
        if (this.question.options) {
          this.question.options.forEach(option => option["selected"] = false);
        }      
      }
      
      this.CheckValidations();
      this.childQuestion.emit(this.question);
      this.cdr.markForCheck();      
    }
  }

  ngDoCheck()
  {
    if(this.question.errorMessage)
    {
      this.CheckValidations();
    }
  }   

  // ngOnInit() {
  //   this.question["IsValid"] = true;
  //   this.validationerrormessage = [];
  //   this.errormgvisible = false;
    
  //   // Set initial selected state if responseText exists
  //   if (this.question && this.question.options) {
  //     this.question.options.forEach((option, index) => {
  //       option["selected"] = option.value === this.question.responseText;
  //     });
  //     this.cdr.detectChanges();
  //   }
  // }
 
  
  
  
  // onSelect(newValue, index, question) {  
  //   question.options.forEach((e) => { e.selected = false; });    
  //   this.question["responseText"] = newValue;
  //   question.options[index].selected = true;
  //   this.question.responseText = question.options[index].value;
  //   this.CheckValidations();
  // }
  CheckValidations() {
  this.errormgvisible = false;
  this.validationerrormessage = [];

  const isRequired = this.question.isQuestionRequired === "Y";
  const value = this.question["responseText"];
  const isEmpty = !value || (typeof value === 'string' && value.trim().length === 0);

  if (isRequired && isEmpty) {
    this.question["IsValid"] = false;
    this.errormgvisible = true;
    this.validationerrormessage.push("Input is mandatory");
  } else {
    this.question["IsValid"] = true;
  }

  //this.childQuestion.emit(this.question);
}
  // onSelect(event:MatRadioChange, question, index :number) {
     
  //   //Make Selected to false
  //   question.options.forEach((e) => { e.selected = false; });   
  //   //Update Selected to true for newValue
  //   this.question["responseText"] = event.value;
  //   question.options[index].selected = true;
  //   this.question.responseText = question.options[index].value;
  //   this.CheckValidations();
  //   //this.inputChange.emit(this.question);
  //   this.childQuestion.emit(this.question);
  // }


  //selectedValue: string;

  ngOnInit() {
    this.question["IsValid"] = true;
    this.validationerrormessage = [];
    this.errormgvisible = false;
    //this.selectedValue = this.question.responseText;
  }

  onRadioClick(event: MouseEvent, value: string, index: number) {
    // If clicking the same value, do nothing
    if (value === this.question.responseText) {
      return;
    }

    // Prevent default radio button behavior to wait for parent's response
    event.preventDefault();
    event.stopPropagation();

    const updatedQuestion = { ...this.question };
    updatedQuestion.responseText =  value;
    updatedQuestion.options = [...this.question.options];

    // First emit the check event and wait for parent's decision from pop up if any conditonal questions are there 
    this.conditionalChange.emit({
      question: updatedQuestion,
      oldResponse: this.question.responseText,
      newResponse: value,
      proceed: (shouldProceed: boolean) => {
        this.zone.run(() => {
          if (shouldProceed) {
            // Update both the model and view state
            //this.selectedValue = value;
            this.question.responseText = value;
            // Update radio button states
            this.question.options = this.question.options.map(opt => ({
              ...opt,
              selected: opt.value === value
            }));

            // Run validations and emit changes
            //this.CheckValidations();
            //this.childQuestion.emit(this.question);

            this.inputChange.emit(true); // Emit input change event only when value changes
          }
          
          // Force the view to update in both cases
          this.cdr.markForCheck();
          this.cdr.detectChanges();
          this.CheckValidations();
          this.childQuestion.emit(this.question);
        });
      }
    });
  }
  
}
